<template>
  <div id="login">
    

    <section class="pantalla" data-aos="fade-up" data-aos-delay="200">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>
            <div class="version abs blanco fpG">
              {{this.$store.state.version}}
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <div class="">
                  <span class="fpXG amarillo">
                    ADMINISTRACIÓN
                  </span>
                </div>
              </div>
            </div>
            <div class="row forms no-gutters pt5">
              
              <div class="col-4">
                <div class="botonera">
                  <ul>
                    <li :class="{ active: showLoginForm }">
                      <button class="ls6 lighter">
                        LOGIN
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-8">
                
                <form v-if="showLoginForm" @submit="login($event)">
                  <div class="pb4 px-2">
                    <div class="w-100">
                      <input
                        v-model.trim="loginForm.email"
                        type="text"
                        placeholder="Email"
                        id="email1"
                        required
                      />
                    </div>
                    <div class="w-100">
                      <input
                        v-model.trim="loginForm.password"
                        type="password"
                        placeholder="Contraseña"
                        id="password1"
                        required
                      />
                    </div>
                    <div
                      class="w-100 text-center"
                    >
                    <button type="submit" class="btn-generico">ENTRAR</button>
                    </div>
                  </div>
                </form>

                <form v-else @submit="signup($event)">
                  <div class="col-12 text-center pb-4">
                    <h2>
                      <span class="bold">Regístrate</span> para participar
                    </h2>
                  </div>
                  <div class>
                    <div class="row pb-4">
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.nombre"
                          type="text"
                          placeholder="Nombre"
                          id="nombre"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.apellido"
                          type="text"
                          placeholder="Apellido"
                          id="apellido"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.email"
                          type="text"
                          placeholder="Email"
                          id="email2"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.celular"
                          type="text"
                          placeholder="Celular (10 dígitos)"
                          id="celular"
                          maxlength="10"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.password"
                          type="password"
                          placeholder="Contraseña"
                          id="password2"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <input
                          v-model.trim="signupForm.fecha_nacimiento"
                          :type="dateType"
                          placeholder="Fecha de nacimiento"
                          id="fecha_nacimiento"
                          @click="cambiaFechaType()"
                          @focus="cambiaFechaType()"
                          required
                        />
                      </div>
                    </div>
                    <div class="row pb-5">
                      <div class="col-12 text-center"></div>
                    </div>
                  </div>
                  <div class="extras text-center">
                    <a @click="toggleForm()" class="rojo pointer fG"
                      >Regresar al Log In</a
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section data-aos="fade-up" data-aos-delay="200">
      <div class="container py-5">
        <div class="row text-center">
          <div class="col-12">
            <router-link to="/" class="pointer img-fluid">
              Ir al home
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";
import Confetti2 from "@/components/Confetti2";
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("loginAdministrador", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.showMonedero = true;
    },
    async registro(monedero = "") {
      this.signupForm.monedero = monedero;
      console.log({ registro: this.signupForm });
      await this.$store.dispatch("signup", this.signupForm);

      this.showMonedero = false;
      this.resetForm();
      this.toggleForm();
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
